// URL base del API. Se hornea en build desde VUE_APP_API_URL (por hotel/despliegue);
// si no se define, mantiene el comportamiento histórico (prod Mansión / localhost dev).
export const API_URL =
  process.env.VUE_APP_API_URL ||
  (process.env.NODE_ENV === "production"
    ? "https://api.hotelmansiondelviajero.com/api"
    : "http://localhost:8000/api");

// Base para construir URLs absolutas a PDFs servidos por el backend.
export const PDF_BASE_URL = process.env.VUE_APP_PDF_BASE_URL || API_URL;

// Token de las pantallas públicas de cocina/barra (rutas *-publico?token=...).
// Debe coincidir con PANTALLA_TOKEN del .env del backend de ESTE hotel; como ese
// token es distinto por hotel, si no se define aquí las pantallas públicas
// responden 403 y nunca cargan pedidos. El default mantiene el valor histórico
// que estaba hardcodeado en las pantallas (Loma).
export const PANTALLA_TOKEN =
  process.env.VUE_APP_PANTALLA_TOKEN || "pantalla_loma_2026";
